import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { IMeResponse, QUERY_KEYS } from "../../types/api";
import { authApi } from "../../services/auth.api";

// Hook for fetching logged in user details
export const useGameProfile = (
  options?: Omit<
    UseQueryOptions<IMeResponse, Error, IMeResponse, [typeof QUERY_KEYS.AUTH]>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.AUTH],
    queryFn: () => authApi.gameProfile(),
    retry: false, // Retry once if failed
    ...options,
  });
};

export const userHooks = {
  useGameProfile,
};
